module.exports = __webpack_public_path__ + "static/media/3.5e0a09bb.png";